import React from "react";
import { Link } from "gatsby";
import BackgroundImage from "gatsby-background-image";

import styles from "./Tile.module.scss";

const Tile = ({
  project: {
    node: { link, menu_image, name, active },
  },
}) => {
  return active ? (
    <Link to={`/portfolio/${link}`} className={styles.self}>
      <BackgroundImage
        className={styles.background}
        Tag="section"
        fluid={menu_image.childImageSharp.fluid}
      >
        <div className={styles.gradient} />
        <p className={styles.name}>{name}</p>
      </BackgroundImage>
    </Link>
  ) : (
    <div className={styles.self}>
      <BackgroundImage
        className={styles.background}
        Tag="section"
        fluid={menu_image.childImageSharp.fluid}
      />
    </div>
  );
};

export default Tile;
